import { TenantLegalDocuments } from 'graphql/generated/graphqlTypes';
import { tenantLegalDocumentsVar } from 'state/vars';

export const setTenantLegalDocumentsAction = (tenantLegalDocuments: TenantLegalDocuments) => {
  tenantLegalDocumentsVar(tenantLegalDocuments);
};

export const updateTenantLegalDocumentsAction = () => {
  const currentTenantLegal = tenantLegalDocumentsVar();
  if (currentTenantLegal) {
    const updatedTenantLegal = {
      ...currentTenantLegal,
      dpa: { ...currentTenantLegal.dpa, acceptedVersion: currentTenantLegal.dpa.currentVersion },
      sla: { ...currentTenantLegal.sla, acceptedVersion: currentTenantLegal.sla.currentVersion }
    };

    tenantLegalDocumentsVar(updatedTenantLegal);
  }
};
